import { array, object, string, number } from 'yup';
import {
  EmailRegex,
  EnglishAlphabetsAndWhiteSpace,
  ImageURLRegex,
} from '../Validator.js';

const PriceSchema = object().shape({
  currency: string().required(),
  value: number().positive().required(),
});

const ImageURLSchema = string().matches(ImageURLRegex);

const ImagesSchema = array()
  .compact()
  .compact(image => !image.hero_image)
  .of(
    object().shape({
      links: object().shape({
        '70px': ImageURLSchema.required(),
        '350px': ImageURLSchema.required(),
        '1000px': ImageURLSchema.required(),
      }),
    })
  );

const EmailSchema = translate =>
  string()
    .email(translate('bookerDetails.message.emailError'))
    .matches(EmailRegex, translate('bookerDetails.message.emailError'))
    .required();

const NameSchema = translate =>
  string()
    .min(1)
    .max(
      32,
      translate('guestDetails.message.maxLengthError', {
        field: translate('guestDetails.name'),
        length: 32,
      })
    )
    .matches(
      EnglishAlphabetsAndWhiteSpace,
      translate('guestDetails.message.alphabetsError')
    )
    .required();

export { EmailSchema, NameSchema, PriceSchema, ImageURLSchema, ImagesSchema };
